import React, { useEffect,useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Circles } from  'react-loader-spinner'
import PrivateSection from './PrivateSection';
import PublicRoutes from './PublicRoutes';
import AdminRoutes from './adminprivate'
import { useNavigate } from "react-router-dom";
import {getSessionId, getToken,getUser,removeUserSession} from '../util'
function Routes(props) {
    let data = localStorage.getItem('login');
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const [authLoading, setAuthLoading] = useState(true);
    const [isUserLoggedIn,setIsUserLoggedIn] = useState(false);
    const [admin,setAdmin]=useState(false)
    useEffect(() => {
    //removeUserSession()
     if (data==='customer'){
        setAdmin(false)
        window.scrollTo(0, 0);
        const token = getToken();
        if (!token) {
            setAuthLoading(false);
            return;
        }
        fetch(`eadmin/v1/set/check_token`, {
            method: 'POST',
            headers: {
            Accept: 'application/json', 
            'Content-Type': 'application/json',
            },
            body: JSON.stringify({token:token,}),
        }).then((response) => response.json())
        .then((responseJson) => {
            if(responseJson.status){
                setIsUserLoggedIn(true)
            }else{
                setIsUserLoggedIn(false)
                removeUserSession();
            }
            setAuthLoading(false);
        }).catch((error) => {
            alert(error)
        });
        }else{
            window.scrollTo(0, 0);
                const token = getToken();
                if (!token) {
                    setAuthLoading(false);
                    return;
                }
                fetch(`eadmin/v1/set/admin_check_token`, {
                    method: 'POST',
                    headers: {
                    Accept: 'application/json', 
                    'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({token:token,}),
                }).then((response) => response.json())
                .then((responseJson) => {
                    if(responseJson.status){
                        setIsUserLoggedIn(true)
                        setAdmin(true)
                    }else{
                        setAdmin(false)
                        removeUserSession();
                    }
                    setAuthLoading(false);
                }).catch((error) => {
                    alert(error)
                });
        }
    }, [pathname]);
    const logOutUser=()=>{
        onLogOutSave()
        removeUserSession()
        navigate("/login");
        localStorage.removeItem("length")
        setIsUserLoggedIn(false)
    }
    const onLogOutSave=()=>{
        
        let currentDate = new Date();
      // alert(JSON.stringify(getUser()))
        const showTime = currentDate.getHours() 
            + ':' + currentDate.getMinutes() 
            + ":" + currentDate.getSeconds();

          let json_data={logoutby:getUser().registerno,sessionid:getSessionId()}
          fetch(`eadmin/v1/set/update_userloginlog`, {
          method: 'POST',
          headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          },
          body:(JSON.stringify(json_data)),
          }).then((response) => response.json())
          .then((responseJson) => {
            if(!responseJson.status){
              
            }
           
          }).catch((error) => {
            alert(error)
          });
        }
     
    if (authLoading) {
        return(
            <div  style={{marginLeft:'50%',marginTop:'20%'}}>
                <center><Circles color="#4A148C"/></center>
            </div>
             //isUserLoggedIn ? admin ? <AdminRoutes />:<PrivateSection logOut={logOutUser}/>: <PublicRoutes />
        )  
    }
    else
        return   isUserLoggedIn ? admin ? <AdminRoutes/>:<PrivateSection logOut={logOutUser}/>: <PublicRoutes />
}


export default Routes;
